import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';

export const LikeCount = ({ numberOfLikes }: { numberOfLikes: number }): React.JSX.Element => {
	return (
		<Inline space="space.050">
			<Text as="span" size="small">
				👍
			</Text>
			<Text size="small">{numberOfLikes}</Text>
		</Inline>
	);
};
